//export { default as Account } from './Account';
export { default as Dashboard } from './Dashboard';
// export { default as Icons } from './Icons';
export { default as NotFound } from './NotFound';
// export { default as ProductList } from './ProductList';
// export { default as Settings } from './Settings';
export { default as SignIn } from './SignIn';
// export { default as SignUp } from './SignUp';
// export { default as Typography } from './Typography';
// export { default as UserList } from './UserList';
export { default as Category } from './Category';
export { default as Player } from './Advertise/Player';
export { default as AddressDB } from './Advertise/AddressDB';
export { default as Template } from './Advertise/Template';
export { default as Campaign } from './Campaign';
export { default as Company } from './Company';
export { default as Device } from './Device';
export { default as Statistics } from './Statistics';
export { default as Settlement } from './Settlement';
export { default as Manage } from './Manage';
